/* eslint-disable complexity */
import store from 'store';
import { http } from 'http';
import NProgressApp from 'utils/nprogress';
import { AUTH_REQUEST } from 'store/actions/auth';
import { lsGetAuthTokenBBVA, lsGetAuthToken2faBBVA } from 'helpers/store';

// Request interceptor
http.interceptors.request.use(
  config => {
    const loading = config.loading !== undefined ? config.loading : true;
    // const authBtk = config.authBtk !== undefined ? config.authBtk : false;
    const authBtk2fa = config.authBtk2fa !== undefined ? config.authBtk2fa : false;
    const tokenBBVA = lsGetAuthTokenBBVA();
    const tokenBBVA2fa = lsGetAuthToken2faBBVA();
    if (loading) NProgressApp.start();
    if (
      store.getters['auth/isAuthenticated'] &&
      config.headers['content-type'] !== 'application/x-www-form-urlencoded'
    ) {
      config.headers.Authorization = `${store.getters['auth/tokenType']} ${store.getters['auth/accessToken']}`;
    }

    if (tokenBBVA) {
      config.headers['auth-btk'] = tokenBBVA;
      // config.headers['auth-btk'] = `${tokenBBVA.token_type} ${tokenBBVA.access_token}`; Antiguo
    }

    if (authBtk2fa && tokenBBVA2fa) {
      config.headers['auth-btk-2fa'] = tokenBBVA2fa.token2fa;
    }

    return config;
  },
  error => Promise.reject(error.data)
);

// Response interceptor
http.interceptors.response.use(
  response => {
    const loading = response.config.loading !== undefined ? response.config.loading : true;
    if (loading) {
      NProgressApp.done();
    }
    return Promise.resolve(response);
  },
  error => {
    NProgressApp.done();
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      // if the error is 401 and hasent already been retried
      originalRequest._retry = true; // now it can be retried
      return store
        .dispatch(`auth/${AUTH_REQUEST}`)
        .then(
          () => http(originalRequest) // retry the request that errored out
        )
        .catch(() => {
          for (let i = 0; i < error.response.data.errors.length; i += 1) {
            if (error.response.data.errors[i] === 'TOKEN-EXPIRED') {
              // Do something
              return;
            }
          }
        });
    }

    // Do something with response error
    return Promise.reject(error);
  }
);
